const compliance = [
  {
    tabName: "Disputes",
    path: "/compliance/disputeList/DisputeList",
    authority: ["OPERATION", "OPERATION_ADMIN", "COMPLIANCE"],
    rolePermission: "RISK_DISPUTES",
    page: [],
  },
  {
    tabName: "Dispute #",
    path: "/compliance/disputeDetail/DisputeDetail",
    authority: ["OPERATION", "OPERATION_ADMIN", "COMPLIANCE"],
    rolePermission: "RISK_DISPUTES",
    showInSidebar: false,
    page: [],
  },
];

export default compliance;
